import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import TileStandardContext from '../../context/TileStandardContext';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-carousel-control.scss';

import type { TileStandardCarouselDirection } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('../tile-standard-carousel.i18n.json'));

type Props = {
  direction: TileStandardCarouselDirection,
  isDisabled: boolean,
  skipTooltip?: boolean
};

const MSG_KEY = 'tile_standard_carousel';

const TileStandardCarouselControl = (
  {
    direction,
    isDisabled,
    skipTooltip = false
  }: Props
): JSX.Element => {
  const content = React.useContext(TileStandardContext);

  const containerClasses = classnames('tile-standard-carousel-control', {
    'tile-standard-carousel-control--disabled': isDisabled,
    [`tile-standard-carousel-control--${direction}`]: direction
  });

  const chevron = direction === 'prev'
    ? 'chevron-left-custom-fg'
    : 'chevron-right-custom-fg';

  const handleClick = (event: SyntheticEvent<HTMLElement>): void => {
    const target = event.currentTarget;
    const currentDirection = target.dataset.direction || '';

    if (currentDirection && content) {
      const updatedCarouselIndex = currentDirection === 'prev'
        ? content.carouselIndex - 1
        : content.carouselIndex + 1;

      content.onSetCarouselIndex(updatedCarouselIndex);
    }
  };

  const renderIcon = (): JSX.Element => <SVGDynamicIcon
    name={chevron}
    width={17}
    height={17}
    customColor="white"
  />;

  const renderTooltip = (): JSX.Element => (
    <Tooltip
      message={__t(`${MSG_KEY}.tooltips.no_content`)}
      width="auto-compact"
      display="flex"
      classNameWrapper="tile-standard-carousel-control__tooltip"
    >
      {renderIcon()}
    </Tooltip>
  );

  return (
    <div
      className={containerClasses}
      data-direction={direction}
      {...(!isDisabled ? { onClick: handleClick } : null)}
    >
      {
        (isDisabled && !skipTooltip)
          ? renderTooltip()
          : renderIcon()
      }
    </div>
  );
};

export default TileStandardCarouselControl;
